module.exports = __webpack_public_path__ + "static/media/bed.e3401bbb.svg";